import script from "./Ad.vue?vue&type=script&setup=true&lang=js"
export * from "./Ad.vue?vue&type=script&setup=true&lang=js"

import "./Ad.vue?vue&type=style&index=0&id=f39c8fc6&scoped=true&lang=css"

import exportComponent from "D:\\20231109nkGg7QhS(1)\\20231109nkGg7QhS\\vueweb\\vue-antd-tool-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f39c8fc6"]])

export default __exports__